export default __webpack_public_path__ + "/dist/images/222181.5c4c171daf6c07cfeac474551fd63f53.png";